<template>
  <f7-page name="chatgroups" @page:beforein="init">
    <f7-navbar title="Sports Update" back-link="Back"></f7-navbar>
    <f7-block>
      <f7-block>
        <h4>Premier League Updates</h4>
        <p>Powered By Google Alert</p>
        <f7-row>
          <f7-col width="100" medium="50"
            ><p v-for="(score, index) in monthblogger" :key="index">
              <b>{{ score.title }}</b> <br />{{ score.content }}

              <f7-link :href="score.link" external> Read More --> </f7-link>
            </p>
          </f7-col>
        </f7-row>

        <h4>Spain La Liga Sports Updates</h4>
        <f7-row>
          <f7-col width="100" medium="50"
            ><p v-for="(score, index) in weekblogger" :key="index">
              <b>{{ score.title }}</b> <br />{{ score.content }}

              <f7-link :href="score.link" external> Read More --> </f7-link>
            </p></f7-col
          >
        </f7-row>

        <h4>Germany - Bundesliga Sports Updates</h4>
        <f7-row>
          <f7-col width="100" medium="50"
            ><p v-for="(score, index) in todayblogger" :key="index">
              <b>{{ score.title }}</b> <br />{{ score.content }}

              <f7-link :href="score.link" external> Read More --> </f7-link>
            </p></f7-col
          >
        </f7-row>

        <h4>French - Ligue1 Sports Updates</h4>
        <f7-row>
          <f7-col width="100" medium="50"
            ><p v-for="(score, index) in everydayblogger" :key="index">
              <b>{{ score.title }}</b> <br />{{ score.content }}

              <f7-link :href="score.link" external> Read More --> </f7-link>
            </p></f7-col
          >
        </f7-row>
        <p>Source: Google Alert</p>
      </f7-block>
    </f7-block>
  </f7-page>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      userCountry: null,
      text1: "Join Chatme24 to meet new friends",
      text2: "Join Miss Comely to meet new friends",
      everydayblogger: [],
      weekblogger: [],
      monthblogger: {
        type: Array,
        default: () => [{}],
      },
      todayblogger: [],
    };
  },
  watch: {
    user_country(value) {
      if (value != null) {
        // this.blog(value);
      }
    },
  },
  methods: {
    advertrouter(group) {
      this.$f7router.navigate("https://247sms.com", External);
    },
    gotoJoinGroup(payload) {
      this.$store.dispatch("addGroupMember");
      this.$store.commit("setAlertMessage", "You have been added to the group");
    },
    gotoGroup(group) {
      this.$f7router.navigate("/chatgroup/");
    },
    init() {
      this.$store.commit("setShowTabs", true);
      //console.log("Country3");
      //      this.$store.dispatch("getMyGroups");
      //this.$store.commit("setUserCountry", null);
      //this.$store.dispatch("getUserCountry");
      //this.blog(userCountryBlog);

      var mycountry = "";
      this.$f7ready((f7) => {
        //console.log("country2", this.userCountry);
        firebase
          .database()
          .ref("users")
          .child(firebase.auth().currentUser.uid)
          .once("value", (snapshot) => {
            mycountry = snapshot.val().country;
            // console.log("nosa country", snapshot.val().country);

            var postData = {
              country: mycountry,
            };

            const self = this;
            const app = self.$f7;
            app.request.post(
              "https://chatme24.com/register/sportsnewsupdatefrench.php",
              postData,
              function (data) {
                var obj = JSON.parse(data);
                //console.log(obj);
                self.everydayblogger = obj;
                //console.log(self.todayblogger.name);
              }
            );

            app.request.post(
              "https://chatme24.com/register/sportsnewsupdategermany.php",
              postData,
              function (data) {
                var obj = JSON.parse(data);
                //console.log(obj);
                self.todayblogger = obj;
                //console.log(self.todayblogger.name);
              }
            );

            app.request.post(
              "https://chatme24.com/register/sportsnewsupdatespain.php",
              postData,
              function (data) {
                var obj = JSON.parse(data);
                //console.log(obj);
                self.weekblogger = obj;
                //console.log(self.todayblogger.name);
              }
            );

            app.request.post(
              "https://chatme24.com/register/sportsnewsupdateengland.php",
              postData,
              function (data) {
                var obj = JSON.parse(data);
                //console.log(data);
                self.monthblogger = obj;
                // console.log(self.monthblogger);
              }
            );
          });
      });
    },
  },
  computed: {
    advert_default() {
      //console.log("advert logs", advert_default);
      return this.$store.getters.advert_default;
    },
    advert_country() {
      return this.$store.getters.advert_country;
    },

    chat_groups() {
      return this.$store.getters.chat_groups;
    },
    user_country() {
      return this.$store.getters.user_country;
    },
  },

  mounted() {},
  created() {
    this.init();
    this.$store.dispatch("getAppDbVersion");
    this.$store.dispatch("getAppVersion");
    this.$store.dispatch("getAdvertDefault");
    this.$store.dispatch("getAdvertCountry");
  },
};
</script>

<style scoped>
.wrapper {
  text-align: center;
}
.small-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
.image--cover {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}
</style>
